




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

@Component<Select>({
    name: 'Select',
})
export default class Select extends Vue {
    @Prop({ type: Boolean, default: false }) private disabled!: boolean;
    @Prop({ type: Array, default: () => [] }) private options!: { value: any; label: string; }[];
    @Prop({ type: String, default: 'Select' }) private placeholder !: string;
    @Prop({ default: '' }) private value!: any;
    @Prop({ type: String, default: 'large'}) private size!: string;
    @Prop({ type: Boolean, default: false }) private multiple!: boolean;
    @Prop({ type: Number, default: 0}) private multiple_limit!: number;
    @Prop({ type: Boolean, default: true}) private collapseTags!: boolean;
    @Prop({ type: String, default: ''}) private itemKey!: string;
    @Prop({ type: Boolean, default: false}) private clearable!: boolean;
    private compTerms = compTerms;
    
    get model() {
        return this.value === [] || this.value === {} ? '' : this.value;
    }
    set model(v) {
        this.$emit('input', v);
        this.$emit('change', v);
    }
}
